import React, { FC, useState } from 'react'
import './CreateAsset.scss'
import { useForm } from 'react-hook-form'
import Swal from 'sweetalert2'
import LeaseAssetService from 'Services/leaseAssetServices'

export type createAssetType = {
  leaseAgreementDurationMonths: number
  valuation: number
  interestRate: number
  investorTenureMonths: number
  // showActualValuation: boolean
  // tenureStartDate: string
}

interface propsType {
  toggleModal: () => void
  onSuccess: () => void
}

const CreateAsset: FC<propsType> = ({ toggleModal, onSuccess }) => {
  const [request, setRequest] = useState(false)

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<createAssetType>()

  const submit = async (data: createAssetType) => {
    console.log('data submit', data)

    setRequest(true)

    await LeaseAssetService.create({
      ...data,
      leaseAgreementDurationMonths: +data.leaseAgreementDurationMonths,
      valuation: +data.valuation,
      interestRate: +data.interestRate,
      investorTenureMonths: +data.investorTenureMonths,
    }).then(
      (response) => {
        setRequest(false)
        toggleModal()
        onSuccess()
        Swal.fire({
          icon: 'success',
          title: 'Done!',
          text: 'Lease Asset creaated succesfully',
          showConfirmButton: false,
          timer: 3000,
        })
      },
      (error: { response: { data: { error: string } } }) => {
        console.log('error', error.response)
        setRequest(false)
        Swal.fire({
          icon: 'warning',
          title: 'Oops!',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 3000,
        })
      },
    )
  }

  return (
    <div className='create-subscription'>
      <form onSubmit={handleSubmit(submit)} className='mt-1 mb-5'>
        <div className='form-group mb-3'>
          <label htmlFor='valuation'>Valuation</label>
          <input
            type='text'
            id='valuation'
            className={errors.valuation ? 'form-control is-invalid' : 'form-control'}
            {...register('valuation', { required: 'field can not be empty' })}
          />
          {errors.valuation && <div className='error text-danger'>{errors.valuation.message}</div>}
        </div>
        <div className='form-group mb-3'>
          <label htmlFor='interestRate'>Interest Rate</label>
          <input
            type='number'
            id='interestRate'
            className={errors.interestRate ? 'form-control is-invalid' : 'form-control'}
            {...register('interestRate', { required: 'field can not be empty' })}
          />
          {errors.interestRate && (
            <div className='error text-danger'>{errors.interestRate.message}</div>
          )}
        </div>
        <div className='form-group mb-3'>
          <label htmlFor='leaseAgreementDurationMonths'>
            Years left on lease agreement in months
          </label>
          <input
            type='number'
            id='leaseAgreementDurationMonths'
            className={
              errors.leaseAgreementDurationMonths ? 'form-control is-invalid' : 'form-control'
            }
            {...register('leaseAgreementDurationMonths', { required: 'field can not be empty' })}
          />
          {errors.leaseAgreementDurationMonths && (
            <div className='error text-danger'>{errors.leaseAgreementDurationMonths.message}</div>
          )}
        </div>
        <div className='form-group mb-3'>
          <label htmlFor='investorTenureMonths'>Investment duration in months</label>
          <input
            type='number'
            step='any'
            id='investorTenureMonths'
            className={errors.investorTenureMonths ? 'form-control is-invalid' : 'form-control'}
            placeholder='0'
            {...register('investorTenureMonths', { required: 'field can not be empty' })}
          />
          {errors.investorTenureMonths && (
            <div className='error text-danger'>{errors.investorTenureMonths.message}</div>
          )}
        </div>

        {/* <div className='form-group mb-3 d-none'>
          <label htmlFor='showActualValuation'>
            Show Actual Valuation
            <input
              type='checkbox'
              id='showActualValuation'
              {...register('showActualValuation')}
              className='ms-2'
            />
          </label>
        </div> */}

        {/* <div className='form-group mb-3'>
          <label htmlFor='tenureStartDate'>Tenure Start Date</label>
          <input
            type='datetime-local'
            id='tenureStartDate'
            className={errors.tenureStartDate ? 'form-control is-invalid' : 'form-control'}
            {...register('tenureStartDate', { required: 'field can not be empty' })}
          />
          {errors.tenureStartDate && (
            <div className='error text-danger'>{errors.tenureStartDate.message}</div>
          )}
        </div> */}
        <div className='form-input mt-3'>
          <button className='btn' type='submit' disabled={request}>
            Create Asset {request && <span className='spinner-border spinner-border-sm'></span>}
          </button>
        </div>
      </form>
    </div>
  )
}

export default CreateAsset
